import React from 'react';
import Button from '../../Button';
import Col from '../../Col';
import Diagnosis from '../../Diagnosis/Diagnosis';
import ServiceRequestFormDialog from '../ServiceRequestFormDialog';
import FontAwesomeIcon from '../../Icon';
import Row from '../../Row';
import { variables } from 'src/Tenants';
import Progress from 'src/components/ServiceRequestForm/Progress/Progress';
import {
  useServiceRequestFormCategoryOrchestrator,
  UseServiceRequestFormCategoryOrchestratorReturn,
} from './useServiceRequestFormCategoryOrchestrator';
import './ServiceRequestFormCategory.scss';

const ServiceRequestFormCategory = () => {
  const {
    diagnosisAsset,
    diagnosisIssueType,
    warrantyExpiresAt,
    visibleCategories,
    onSelectCategory,
    onSkipToDetails,
    onBack,
    onExit,
  }: UseServiceRequestFormCategoryOrchestratorReturn =
    useServiceRequestFormCategoryOrchestrator();

  return (
    <ServiceRequestFormDialog
      title="Let's Identify the Issue"
      description="Tell us what's happening and we'll  be able to find the right solution to get your home back to normal."
      onBack={onBack}
      onExit={onExit}
      footer={
        <>
          <span className="service-request-form-category__prompt">
            Haven't found your answer?
          </span>
          <Button
            color="teal"
            size="small"
            label="Next: Add Details"
            onClick={onSkipToDetails}
          />
        </>
      }
    >
      <div className="requestProgress">
        <Row mdCenter>
          <Col xs="12" md="6">
            <Diagnosis
              asset={diagnosisAsset}
              issueType={diagnosisIssueType}
              expiresAt={warrantyExpiresAt}
            />
            <Progress currentStep={2} totalSteps={3} />
            <div className="service-request-form-category__title">
              Common Questions
            </div>
            <div className="service-request-form-category__subtitle">
              One of these might already solve your issue before you submit a{' '}
              {variables.serviceRequest}.
            </div>
            <div className="service-request-form-category__items">
              {visibleCategories.map((category: any) => (
                <button
                  key={category.id}
                  className="service-request-form-category__item"
                  onClick={() => onSelectCategory(category)}
                  type="button"
                >
                  {category.question}
                  <FontAwesomeIcon weight="light" glyph="chevron-right" />
                </button>
              ))}
            </div>
          </Col>
        </Row>
      </div>
    </ServiceRequestFormDialog>
  );
};

export default ServiceRequestFormCategory;